import { Paper, Button } from '@mui/material';
import { IconProfile, IconLot, IconAdd, IconMechanicalsColor } from 'icons';
import Authorize from 'components/Authorize/Authorize';
import { permissionProfiles } from 'components/Authorize/permissionProfiles';
import { PRICING_TABS, PRICING_TAB_LABELS } from './PricingManagementConsts';
import QuickLookup from './QuickLookup/QuickLookup';
import PricingByClient from './PricingByClient/PricingByClient';
import PricingByLot from './PricingByLot/PricingByLot';
import PricingByActivity from './PricingByActivity/PricingByActivity';
import { useActivityPricingStyles } from './PricingManagementStyles';
import { TabsWrapper } from "components/TabsWrapper/TabsWrapper";
import LoadingSpinner from "../../components/LoadingSpinner";
import CreateActivityAndPricingDialog from './CreateActivityAndPricing/CreateActivityAndPricingDialog';
import BundleDialog from './CreateBundle/BundleDialog';
import { useState } from 'react';
import { theme } from 'styles/theme';
import SearchIcon from '@material-ui/icons/Search';

const PricingManagementPage = () => {
    const classes = useActivityPricingStyles();
    const [openDialog, setOpenDialog] = useState(false);
    const [openBundleDialog, setOpenBundleDialog] = useState(false);

    const isLoading = () => false;


    if (isLoading()) {
        return <LoadingSpinner loading={true} />;
    }


    const tabs = [
        {
            id: PRICING_TABS.QUICK_LOOKUP,
            label: PRICING_TAB_LABELS[PRICING_TABS.QUICK_LOOKUP],
            icon: <SearchIcon />,
            component: <QuickLookup />
        },
        {
            id: PRICING_TABS.BY_CLIENT,
            label: PRICING_TAB_LABELS[PRICING_TABS.BY_CLIENT],
            icon: <IconProfile />,
            component: <PricingByClient />
        },
        {
            id: PRICING_TABS.BY_LOT,
            label: PRICING_TAB_LABELS[PRICING_TABS.BY_LOT],
            icon: <IconLot />,
            component: <div className={classes.byLotTabContent}><PricingByLot /></div>
        },
        {
            id: PRICING_TABS.BY_ACTIVITY,
            label: PRICING_TAB_LABELS[PRICING_TABS.BY_ACTIVITY],
            icon: <IconMechanicalsColor color={theme.palette.primary.main} width={23} height={23} />,
            component: <PricingByActivity />
        }
    ];

    return (
        <Authorize profile={permissionProfiles.PRICING.MANAGE_PPRICING}>
            <Paper className={classes.paper}>
                <div className={classes.headerContainer}>
                    <Button
                        variant="contained"
                        startIcon={<IconAdd />}
                        onClick={() => setOpenBundleDialog(true)}
                        className={classes.createButton}
                    >
                        Create Bundle
                    </Button>
                    <Button
                        variant="contained"
                        startIcon={<IconAdd />}
                        onClick={() => setOpenDialog(true)}
                        className={classes.createButton}
                    >
                        Create Activity
                    </Button>
                </div>
                <BundleDialog
                    open={openBundleDialog}
                    handleClose={() => setOpenBundleDialog(false)}
                />
                <CreateActivityAndPricingDialog
                    open={openDialog}
                    handleClose={() => setOpenDialog(false)}
                />
                <TabsWrapper tabs={tabs} selectedTab={0} />
            </Paper>
        </Authorize>
    );
};

export default PricingManagementPage;
